import { Box, BoxProps } from '@mui/material';
import { styled } from '@mui/material/styles';

const Flag = styled(Box)<BoxProps>(() => ({
  width: '1.8125rem',
  height: '1.125rem',
}));

export default Flag;
